import styles from "./PaymentOption.module.scss";
import classNames from "classnames";
import { paymentContent } from "../tradeInCopyText";
import Tooltip from "@JohnLewisPartnership/jl-design-system/dist/components/tooltip/Tooltip";
import { AvailablePaymentOption } from "../PaymentOptions";

type Props = {
  index: number;
  description: string;
  payment: AvailablePaymentOption;
  selected: boolean;
  onSelect: () => void;
};

const PaymentOption = ({
  index,
  description,
  payment,
  selected,
  onSelect,
}: Props) => {
  const uniqueDescriptor = "paymentBlock" + payment.type;

  return (
    <>
      <div className={styles.payment__tooltip}>
        <Tooltip
          anchor="right"
          icon
          id={"payment-tooltip" + index}
          data-test="payment-tooltip"
          popoverClassname={styles.payment__tooltip_popover}
          ariaDescribedBy={uniqueDescriptor}
        >
          <p>{paymentContent[payment.type].tooltipContent}</p>
        </Tooltip>
      </div>

      <button
        data-testid={"paymentBlock" + index}
        data-cy={uniqueDescriptor}
        className={classNames([
          styles.payment,
          selected && styles["payment--selected"],
        ])}
        key={index}
        onClick={onSelect}
      >
        <span
          className={styles.payment__type}
          data-cy={`payment-type-${payment.type}`}
          id={uniqueDescriptor}
        >
          {paymentContent[payment.type].payout}
        </span>

        <span
          className={styles.payment__inner}
          data-cy={`payment-value-${payment.type}`}
        >
          <span className={styles.payment__description}>{description}</span>
          <span className={styles.payment__value}>{payment.displayValue}</span>
          <span className={styles.payment__valueLabel}>Trade In value</span>
        </span>
      </button>
    </>
  );
};

export default PaymentOption;
